import React, { Component } from 'react';

import './Services.css';

import en from '../../../language/en/Services.json';
import es from '../../../language/es/Services.json';
import { Link } from 'react-router-dom';
import { Typography } from '@material-ui/core';

class Services extends Component {
	constructor() {
		super();
		this.state = {
			newTask: ''
		};
	}

	updateState(e) {
		this.setState({
			newTask: e.target.value
		})
		console.log(this.state);
	}

	sendNewTask(e) {
		e.preventDefault();
		this.props.onAddTask(this.state.newTask);
		console.log('We are sending the new task: "', this.state.newTask, '" wait a moment please');
		this.textInput.value = '';
		this.textInput.focus();
	}

	render() {
		return (

			<section id="service">

				<div className="features-bg">
					<div className="container">
						<div className="heading">
							<Typography variant="h4" className="efecto-espejo">
								Principales Servicios
							</Typography>
						</div>

						<div className="row margin-bottom-70">
							<div className="col-md-6 md-margin-bottom-70">
								<div className="features">
									<img src="assets/frontend/onepage2/img/widgets/screen1.png" alt="" />
									<div className="features-in">
										<h3>Reportes estadísticos & Datos climatológicos</h3>
										<p>Brindamos datos de variables meteorológicas para proyectos comunitarios, interes agrícolas y otros</p>
									</div>
								</div>
							</div>
							<div className="col-md-6">
								<div className="features">
									<img src="assets/frontend/onepage2/img/widgets/screen2.png" alt="" />
									<div className="features-in">
										<h3>Clima de Montaña y estudios PVR</h3>
										<p>Caracterizamos zonas de diversos relieves y contribuimos a estudios de vulnaribilidad ambiental</p>
									</div>
								</div>
							</div>
						</div>
						<div className="row margin-bottom-80">
							<div className="col-md-6 md-margin-bottom-70">
								<div className="features">
									<img src="assets/frontend/onepage2/img/widgets/screen3.png" alt="" />
									<div className="features-in">
										<h3 className="page-scroll">
											<Link to="/service/weather/stations/emas">Sincronización de estaciones automáticas</Link>
										</h3>
										<p>Contamos con una plataforma de sincronización de datos meteorologicos de las estaciones automáticas de la provincia</p>
									</div>
								</div>
							</div>
							<div className="col-md-6">
								<div className="features">
									<img src="assets/frontend/onepage2/img/widgets/map-screen5.png" alt="" />
									<div className="features-in">

										<h3 className="page-scroll">
											<Link to="/service/forecast">Pronóstico especializado por municipios</Link>
										</h3>
										<p>Guiamos a instituciones ante desastres meteorológicos</p>
									</div>
								</div>
							</div>
						</div>

						<center>
							<Link to="/services/all" className="btn-brd-danger">
								Más Servicios
			            	</Link>
						</center>

					</div>
				</div>

			</section>
		);
	}
}

export default Services;